import api from './api';

export interface DashboardStats {
  totalUsers: number;
  activeActivities: number;
  openJobs: number;
  todayLogins: number;
}

export const dashboardService = {
  async stats() {
    const { data } = await api.get<DashboardStats>('/dashboard');
    return data;
  },
};
